import React from "react";
import "./SustainableDevelopment.css";
import sustainableImage from "../assets/images/sustainable-development.jpg";

const SustainableDevelopment = () => {
  return (
    <>
      {/* ================= HERO ================= */}
      <section
        className="sustainable-hero"
        style={{ backgroundImage: `url(${sustainableImage})` }}
      >
        <div className="sustainable-hero-overlay" />

        <div className="sustainable-hero-content">
          <h1 className="sustainable-hero-title">
            <span className="green">Sustainable</span>{" "}
            <span className="purple">development</span>
          </h1>
        </div>
      </section>
      {/* ================= IMPACT SECTION ================= */}
<section className="impact-section">

  {/* ROW 1 */}
  <div className="impact-row">
    <div className="impact-left">
      <h2>
        <span className="green">We foster quality employment</span>{" "}
        <span className="purple">and professional development</span>{" "}
        <span className="green">for our team</span>
      </h2>
    </div>

    <div className="impact-right">
      <p>
        Cinfa Group has reinvested an average 80% of its profits over the last
        ten years back into the company itself, thereby fostering development
        and innovation at its businesses.
      </p>

      <p>
        We have created 1,229 jobs in that time. Furthermore, we now have a
        stable team that is constantly evolving and engaged in professional
        development.
      </p>
    </div>
  </div>

  {/* ROW 2 */}
  <div className="impact-row">
    <div className="impact-left">
      <h2>
        <span className="green">We contribute to the sustainability</span>{" "}
        <span className="purple">of the healthcare system</span>
      </h2>
    </div>

    <div className="impact-right">
      <p>
        <strong>
          Generic medicines represent a saving for the public and, at the same
          time, free up resources in the healthcare system for other needs,
          such as improving diagnostic services, shortening waiting lists or
          financial aid to meet the cost of new drugs.
        </strong>
      </p>

      <p>
        Cinfa leads the generic medicines sector in Spain with in excess of
        <strong> 1.7 billion generic medicines marketed</strong> to date.
        In fact, almost <strong>“one in four drugs”</strong> of this type
        dispensed at Spanish pharmacies comes from Cinfa.
      </p>

      <p className="impact-source">
        *Source: IQVIA, December 2023
      </p>
    </div>
  </div>

</section>
{/* ================= COMMITMENTS ================= */}
<section className="commitments-section">
  <h2 className="commitments-title">
    <span className="green">Our</span>{" "}
    <span className="purple">commitments</span>
  </h2>

  <div className="commitments-list">
    <span className="commitment-pill green-border">People move us</span>
    <span className="commitment-pill purple-border">Ethics and transparency</span>
    <span className="commitment-pill green-border">Environmental commitment</span>
    <span className="commitment-pill purple-border">
      Sustainable economic development
    </span>
  </div>
</section>
    </>
  );
};

export default SustainableDevelopment;